import { FC } from 'react';
import AddProductProvider from '../memory/memr';
import InitMiddlewareEditBrand from '../middlewares/InitMiddleware';

const EditBrandInstance: FC<{}> = () => {
  return (
    <AddProductProvider>
      <InitMiddlewareEditBrand />
    </AddProductProvider>
  );
};

export default EditBrandInstance;
